import type { Payload, UserGroupCallbacks } from './types'

export interface State {
  event: Payload | {}
  message: Payload | {}
  userGroupCallbacks: UserGroupCallbacks
}

export const defaultState: State = {
  event: {},
  message: {},
  userGroupCallbacks: {
    addUserToGroup: () => {},
    removeUserFromGroup: () => {},
  },
}
